import {
  SET_CURRENT_USER,
  SET_USERS,
  SET_All_USERS_INACTIVE,
  SET_FETCH_ACTIVE_USERS_ERROR,
} from "../constants/actionTypes";

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    currentUser: user,
  };
}

export function setUsers(users) {
  return {
    type: SET_USERS,
    users: users,
  };
}

export function setAllUsersInactive(user) {
  return {
    type: SET_All_USERS_INACTIVE,
    allUsersInactive: user,
  };
}

export function setFetchActiveUsersError(hasError) {
  return {
    type: SET_FETCH_ACTIVE_USERS_ERROR,
    fetchActiveUsersError: hasError,
  };
}
